<template>
  <div class="feature-video" :class="'-video-state-' + state + ' -view-state-' + intersection">
    <div class="video-player">
      <transition name="fade">
        <div v-if="showPause" @click="play" class="video__cover__icon">
          <play_icon :classes=" 'icon' " />
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showCover" @click="play" class="video__cover | image -fit-cover | bg-snow-100">
          <img role="presentation" :data-src="imgSrc" class="lazyload" />
        </div>
      </transition>
      <div class="video__video | video" :style="`padding:${aspectRatio}% 0 0 0`">
        <div class="video__iframe-cover" @click="pause"></div>
        <iframe
          :src="`https://player.vimeo.com/video/${vimeoId}?controls=false`"
          class
          muted="false"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <!-- <div class="video-controls" @click="restartSoundOn">
      <div
        class="video-control | flex items-center justify-end text-grey-100 hover:text-bronze-100"
      >
        <volume_icon :classes=" 'icon -sm | mr-1 ' "/>
        <div class="header-meta | link | md:pr-0 pr-4">Watch with the sound to learn more</div>
      </div>
    </div>-->
  </div>
</template>
<script>
import "intersection-observer";
import play_icon from "../icons/play--dotted";
import volume_icon from "../icons/volume";
import Player from "@vimeo/player";

export default {
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    videoUrl: {
      type: String,
      required: true
    },
    aspectRatio: {
      type: String,
      required: true
    },
    playInview: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      player: null,
      showCover: true,
      showPause: true,
      playerEl: null,
      state: "loading",
      intersection: "out"
    };
  },

  computed: {
    vimeoId() {
      const match = /vimeo.*\/(\d+)/i.exec(this.videoUrl);
      return match[1];
    }
  },

  methods: {
    setupPlayer() {
      // Elements
      const _this = this;
      _this.playerEl = _this.$el;
      const iframe = _this.playerEl.querySelector("iframe");
      _this.player = new Player(iframe);

      // Settings
      //_this.player.setVolume(0);

      // Events
      // -- ended
      _this.player.on("ended", function() {
        _this.showCover = true;
        _this.showPause = true;
      });
      // -- in view
      if (!!window.IntersectionObserver) {
        _this.inView();
      }

      _this.state = "loaded";
    },
    inView() {
      const _this = this;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            _this.intersection = "in";
            // if (_this.playInview) {
            //  _this.playSoundOff();
            // }
          } else {
            _this.intersection = "out";
            _this.pause();
          }
        });
      });

      observer.observe(_this.playerEl);
    },
    pause() {
      const _this = this;
      _this.showPause = true;
      _this.player.pause();
      _this.state = "paused";
    },
    // playSoundOff() {
    //  const _this = this;
    //  _this.player.setVolume(0).then(function(volume) {
    //    _this.showCover = false;
    //    _this.showPause = false;
    //    _this.player.play();
    //    _this.state = "playing";
    //  });
    //},
    play() {
      const _this = this;
      _this.showCover = false;
      _this.showPause = false;
      _this.player.play();
      _this.state = "playing";
    },
    restartSoundOn() {
      const _this = this;
      _this.player.getCurrentTime().then(function(seconds) {
        _this.player.setVolume(1);
        if (seconds > 0) {
          // Restart
          if (_this.showCover) {
            _this.player.setCurrentTime(0).then(function(seconds) {
              console.log("Restart");
              _this.showPause = false;
              _this.state = "playing";
            });
          }
        } else {
          // Play
          console.log("Play");
          _this.play();
        }
      });
      _this.player.setCurrentTime(0).then(function(seconds) {
        console.log(seconds);
      });
    }
  },

  mounted() {
    const _this = this;
    // On Load
    window.addEventListener("load", function() {
      _this.setupPlayer();
    });
  },

  components: {
    play_icon,
    volume_icon
  }
};
</script>



<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 350ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-leave-to {
  transition-delay: 700ms;
}
</style>
